import { runInAction } from "mobx"
import { observer } from "mobx-react-lite"
import { useContext } from "react"

import { Button } from "@/components/Button/Button.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { pluralize } from "@/lib/displayUtils.ts"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"


export const PreviewErrorsToast = observer((props: {
  errors: Error[]
}) => {
  const taskViewModel = useContext(TaskViewModelContext)
  const inputModel = taskViewModel?.inputModel
  const canSubmit = inputModel?.canSubmit.get() ?? false
  const prompt = inputModel?.firstInputValue

  return (
    <Horizontal alignItems="center" gap="8px">
      <span>
        {`${props.errors.length} ${pluralize("error", props.errors.length)} detected`}
      </span>
      <Button kind="danger" size="small" onClick={() => {
        if (inputModel && prompt) {
          runInAction(() => {
            const errors = props.errors.map((error) => {
              return error.stack && error.message.includes(error.stack) ? error.message : error.message + (error.stack ?? "")
            }).join("\n\n")

            if (prompt.get().length > 0) {
              prompt.set(prompt.get() + "\n\n" + errors)
            } else {
              prompt.set(errors)
            }

            inputModel.highlight()

            if (canSubmit) {
              void inputModel.doSubmit()
            }
          })
        }
      }}>{canSubmit ? "Attempt to fix" : "Copy to chat"}</Button>
    </Horizontal>
  )
})
